export const getTitle = (material) => {
  if (material.name.includes('Starter Kit')) {
    return 'Starter Kit'
  } else {
    return material.name
  }
}
